import {SmartComponent} from "smart-component-js";
import $ from "jquery";
import GigyaManager from "../business/GigyaManager";
import moment from "moment";
import Constants from "../business/Constants";
import PromoApi from "mbpromo/src/api/PromoApi";

class AreaPersonaleCtrl extends SmartComponent {

	constructor(element, parentComponent, params) {
		super(element, parentComponent, params);
		this.promoApi = new PromoApi({promoCode: Constants.API_PROMOCODE});
		this.init();
	}
	init() {
		this.loadChildComponents(this);
		this.startLoader();

		this.promoApi.status().then((resp) => {
			let response = resp.body.response.data;

			if(moment(response.promo.dates.receipt_end_date.raw).diff(moment()) < 0){
				$('.closingStep1').show();
			}else{
				$('.beforeClosing').show();
			}
		});


		GigyaManager.getLoggedUserCached().then((u) => {
			let name = u.profile.firstName;
			let gender = u.profile.gender;
			let msg = $(".custom-msg");
			if (gender === "f"){
				$(msg).html("Benvenuta " + name);
			} else if (gender === "m") {
				$(msg).html("Benvenuto " + name);
			} else {
				$(msg).html("Ciao " + name);
			}

			this.promoApi.areaPersonale().then((resp)=>{
				let body = resp.body;
				let plays = body.response.data.receipts;

				const winningPlays = plays.filter((p => p.status === "WIN"));

				$('#receipt_number').html(winningPlays.length);
				$('.recap-details-label').html(winningPlays.length === 1 ? 'scontrino<br>vincente' : 'scontrini<br>vincenti');
				$('.recap-cnt').html("");
				for (let play of winningPlays) {
					$('.recap-cnt').append(this.buildReceiptTemplate(play));
				}

				// winning plays < 2 => show associa numero
				const totalWinningPlays = winningPlays.length;

				if(totalWinningPlays > 0){
					let winningPlay = winningPlays[0];

					if(winningPlay.shipmentdata.info.prizerequested){
						let prizeMsg = `<p>Acquista in un'unica spesa da Carrefour almeno <strong>2 confezioni tra i prodotti che partecipano all'iniziativa.</strong></p> `;
						$('.edit-content.beforeClosing').html(`${prizeMsg}<a class="button more-padding" href="/promozioni/promocolazione2022/gioca-scontrino">Gioca scontrino</a>`);
					}else {
						$(".custom-msg").html("Hai vinto, complimenti!");
						let prizeMsg =`<p>In regalo per te <strong>1 Weekend in una Casetta sull'Albero!</strong><br>Richiedi il tuo premio e compila tutti i campi necessari, lo riceverai direttamente via e-mail.</p>`;
						$('.edit-content.beforeClosing').html(`${prizeMsg}<a class="button" href="/promozioni/promocolazione2022/completa-dati?pt=${winningPlay.playdata.play_token}&pm=${winningPlay.interface == 'Web' ? '1' : '3'}">Richiedi premio</a>`);
						this.loadChildComponents(this);
					}
				}

				this.removeLoader();
			}, (data)=>{
				this.removeLoader();
				if(data){
					let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__close" component-click="close()">
                                                            <svg>
                                                                <use xlink:href="#svg_circle_close"></use>
                                                            </svg>
                                                        </div>
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Ops, qualcosa è andato storto!</h2>
                                                            <p>${data.body.status.errors.data.description}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
					$(this.element).append(tmplModalGeneric);
					this.loadChildComponents(this);
				}
			})
		}, () => {
			window.location.href = "/login?urlBack="+window.location.href.replace(window.location.origin, "")+"&regSource="+Constants.PROMO_CODE;
		})
	}

	goToPlayReceipt(){
		//TODO Mettere blocco orario!
		window.location.href='/promozioni/promocolazione2022/gioca-scontrino'
	}



	buildReceiptTemplate(obj) {
		let mm_play_date = moment(obj.play_date.raw_format, "YYYY-MM-DD hh:mm:ss");
		mm_play_date.locale('it');

		let playdata = obj.playdata.year + '-' + obj.playdata.month + '-' + obj.playdata.day + ' ' + obj.playdata.hour + ':' + obj.playdata.minutes + ':00';
		playdata = moment(playdata, "YYYY-MM-DD hh:mm:ss");
		playdata.locale('it');
		let html = `
            <div class="recap-row ${obj.status === 'WIN' ? 'done' : ''}">
                <div class="recap-row-content">
                    <div class="recap-date">${mm_play_date.format('LL')}</div>
                    <div>Scontrino del <span class="recap-date-scontrino">${playdata.format('LL')}</span></div>
					<div>Totale € ${obj.playdata.euros},${obj.playdata.cents}</span></div>
                </div>
                ${this.printFeedback(obj)}
            </div>
        `;
		return html;
	}


	printFeedback(obj) {
		const prizeMsg = 'Hai vinto 1 weekend<br>per 4 persone';
		let prizeRequestToDo = ` <span class="content-feedback">
           ${prizeMsg}
        </span>
        <a class="button more-padding" href="/promozioni/promocolazione2022/completa-dati?pt=${obj.playdata.play_token}&pm=${obj.interface == 'Web' ? '1' : '3'}">Richiedi premio</a>`;

		let prizeRequestDone = `
                     <span class="content-feedback">
                        Hai già richiesto il tuo premio
                    </span>`;

		let prizeShipped = `
                     <span class="content-feedback">
                        Premio spedito via email il ${ obj.shipmentdata.info.shipment_date !== "" ? obj.shipmentdata.info.shipment_date.user_friendly_format.partial : ''}
                    </span>`;


		let html = `<div class="recap-row-column"><div class="recap-row-feedback">${obj.shipmentdata.info.prizerequested ? obj.shipmentdata.info.shipment_date !== "" ? prizeShipped : prizeRequestDone : prizeRequestToDo}</div>`;


		let disclaimerCopy = "L’eventuale vincita sarà confermata solo dopo i controlli previsti come da Regolamento";

		if (obj.shipmentdata.info.prizerequested) {
			if (obj.admindata.status == "1") {
				if (obj.shipmentdata.info.shipment_date !== "") {
					disclaimerCopy = `Puoi seguire la spedizione del tuo pacco <a href="${obj.shipmentdata.info.shipment_link}" target="_blank">qui</a>`;
				} else {
					disclaimerCopy = `Complimenti, la tua vincita è stata approvata.`;
				}
			} else if (obj.admindata.status == "0") {
				disclaimerCopy = `La tua vincita non è stata confermata.`;
			} else {
				disclaimerCopy = "L’eventuale vincita sarà confermata solo dopo i controlli previsti come da Regolamento";
			}
		}

		let disclaimer = `<div class="recap-row-feedback additional-text"><p>${disclaimerCopy}</p></div></div>`

		html += disclaimer;

		return obj.status == 'WIN' || obj.status == 'FINAL' ? html : '';
	}

	removeLoader(){
		$('.tool_loader').fadeOut(500).remove();
		$('body').removeClass('noScroll');
	}

	startLoader(){
		$('.mb-promo').append('<div data-tool-loader="" class="tool_loader"><svg><use xlink:href="#svg_loader"></use></svg></div>');
		$('body').addClass('noScroll');
	}

}

export default AreaPersonaleCtrl;
